import { Box, Stack } from '@mui/material';
import { TableData } from 'app/concierge/types';
import MITable from 'components/common/grid/MITable';
import { ColumnType, GridData, GridDataRow } from 'components/common/grid';
import { useEffect, useMemo } from 'react';
import ExpandButton from './expand-button';

interface IProps {
    tableData: TableData;
    messageId?: string;
    conciergeResponse: React.ReactNode | null;
    isStandalone?: boolean;
}

export default function JsonTable({ tableData, messageId, conciergeResponse, isStandalone }: IProps) {
    const { data } = tableData;

    if (!data || data.length === 0) {
        return null;
    }

    const gridColumns = useMemo(() => {
        const columns: ColumnType[] = [];

        if (data.length > 0) {
            const firstRow = data[0];
            Object.keys(firstRow).forEach((key) => {
                const columnName = key
                    .split('_')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');

                columns.push({
                    name: key,
                    title: columnName,
                    sortable: false,
                });
            });
        }

        return columns;
    }, [data]);

    const gridData = useMemo(() => {
        const res: GridData = [];

        data.forEach((row) => {
            const rowData: GridDataRow = {};
            Object.keys(row).forEach((key) => {
                const value = row[key];

                rowData[key] = {
                    component: 'copyText',
                    config: {
                        text: String(value),
                        value: String(value),
                    },
                };
            });
            res.push(rowData);
        });

        return res;
    }, [data]);

    useEffect(() => {
        if (isStandalone) {
            const timer = setTimeout(() => {
                document.body.classList.add('component-ready');
            }, 200);

            return () => {
                clearTimeout(timer);
            };
        }
    }, []);

    if (isStandalone) {
        return (
            <MITable
                gridName={`concierge-table-${messageId}`}
                columns={gridColumns}
                massActionsConfig={{ enabled: false }}
                data={gridData}
                defaultRowHeight={28}
                autoHeight
            />
        );
    }

    return (
        <>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mt: 2 }}>
                    <MITable
                        gridName={`concierge-table-${messageId}`}
                        columns={gridColumns}
                        massActionsConfig={{
                            enabled: false,
                        }}
                        data={gridData}
                        defaultRowHeight={28}
                        autoHeight={gridData.length < 12}
                        height={gridData.length > 12 ? 300 : undefined}
                    />
                </Box>
                <ExpandButton
                    conciergeMessage={conciergeResponse}
                    content={
                        <Box sx={{ width: '100%', mt: 2 }}>
                            <MITable
                                gridName={`concierge-table-${messageId}`}
                                columns={gridColumns}
                                massActionsConfig={{
                                    enabled: false,
                                }}
                                data={gridData}
                                defaultRowHeight={28}
                                autoHeight={gridData.length < 20}
                                height={gridData.length >= 20 ? 600 : undefined}
                            />
                        </Box>
                    }
                />
            </Stack>
        </>
    );
}
